<mat-card
  class="example-card"
  (click)="navigate(goal.tool_URL, goal.tool_permission)"
  *ngIf="authService.hasPermission(goal.tool_permission) && !goal.hidden"
  [ngClass]="{ 'inactive-card': !isActive(goal.tool_permission) }"
  [matTooltip]="
    !isActive(goal.tool_permission) ? 'Contact PAM lab to gain access' : ''
  "
>
  <div class="card-content-flex">
    <svg-icon-viewer
      mat-card-image
      *ngIf="goal.logo_name"
      [svgFileName]="goal.logo_name"
      [width]="goal.icon_width"
    ></svg-icon-viewer>
    <div class="card-content">
      <mat-card-header class="goal-card-header">
        <mat-card-title class="title">{{ goal.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        {{ goal.description }}
      </mat-card-content>
    </div>

    <button
      *ngIf="showMoreInfoIcon"
      (click)="$event.stopPropagation()"
      [matMenuTriggerFor]="menu"
      mat-icon-button
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <mat-list class="hoverable-list">
        <mat-list-item (click)="navigateToHelpPage()">
          <p matListItemTitle>Help</p>
          <mat-icon matListItemIcon style="color: black"> help </mat-icon>
        </mat-list-item>
        <mat-list-item (click)="hideCard()">
          <p matListItemTitle>Hide</p>
          <mat-icon matListItemIcon style="color: black">
            visibility_off
          </mat-icon>
        </mat-list-item>
      </mat-list>
    </mat-menu>
  </div>
</mat-card>
